import { useState, useEffect } from 'react';
import Layout from '../Components/Layout/Layout';
import CategoryList from '../Components/Categories/CategoryList';
import { Button } from "@/Components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { DragDropContext } from '@hello-pangea/dnd';
import axiosInstance from '../utils/axiosConfig';

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const response = await axiosInstance.get('/category/GetCategories');
            const data = await response.data;
            if (Array.isArray(data)) {
                setCategories(data);
            } else if (data.categories && Array.isArray(data.categories)) {
                setCategories(data.categories);
            } else {
                console.error('Unexpected API response format:', data);
                setCategories([]);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        const reorderedCategories = Array.from(categories);
        const [reorderedItem] = reorderedCategories.splice(result.source.index, 1);
        reorderedCategories.splice(result.destination.index, 0, reorderedItem);

        // Update local state immediately for smooth UX
        setCategories(reorderedCategories);

        try {
            // Prepare the order data
            const orderData = reorderedCategories.map((category, index) => ({
                id: category.id,
                order: index + 1
            }));

            // Send the new order to the backend
            await axiosInstance.post('/category/UpdateOrder', orderData);
        } catch (error) {
            console.error('Error updating category order:', error);
            // Optionally revert the order if the API call fails
            fetchCategories();
        }
    };

    const handleCategoryClick = (categoryId) => {
        navigate('/category', {
            state: {
                categoryId: categoryId,
                returnPage: 'categories'
            }
        });
    };

    const handleAddCategory = () => {
        navigate('/category', {
            state: {
                categoryId: 0,
                returnPage: 'categories'
            }
        });
    };

    if (isLoading) return <Layout><div>Loading...</div></Layout>;
    if (error) return <Layout><div>Error: {error}</div></Layout>;

    return (
        <Layout>
            <div className="relative">
                <h2 className="text-xl font-normal font-inter text-ps-blue-dark mb-1">Categorieën</h2>
                <DragDropContext onDragEnd={handleDragEnd}>
                    <CategoryList
                        categories={categories}
                        onCategoryClick={handleCategoryClick}
                    />
                </DragDropContext>
                <div className="flex justify-end mt-8">
                    <Button
                        onClick={handleAddCategory}
                        className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-ps-green hover:bg-ps-green/90 text-white px-4 py-2 shadow-lg rounded-full"
                    >
                        <Plus className="h-6 w-6" />
                        <span>Categorie toevoegen</span>
                    </Button>
                </div>
            </div>
        </Layout>
    );
};

export default Categories;